/**
 * All permission names currently checked anywhere in the frontend.
 *
 * There is no exhaustive backend enum exposed to the client; this list is a
 * best-effort catalog kept in sync manually and used as a fallback when the
 * full role/duty/permission graph can't be fetched (e.g. missing `roles`
 * query access).
 */
const KNOWN_PERMISSION_NAMES = [
    'CREATE_BOM',
    'CREATE_COLLECTION_COLOUR',
    'CREATE_COLLECTIONS',
    'CREATE_STYLES',
    'DELETE_BOM',
    'DELETE_COLLECTION_COLOUR',
    'DELETE_COLLECTIONS',
    'DELETE_STYLES',
    'EDIT_BOM',
    'MANIPULATE_ASSORTMENT_MOQ',
    'MANIPULATE_BRAND_LENGTH',
    'MANIPULATE_COLOUR',
    'MANIPULATE_PURCHASE_DIVISION',
    'MANIPULATE_SIZE_TYPE',
    'MANIPULATE_USER_BRANDS',
    'MANIPULATE_USER_ROLES',
    'SYSTEM_DEVELOPER',
    'TECH_ORDER_ADMIN',
    'UPDATE_COLLECTIONS',
    'UPDATE_DUTY',
    'UPDATE_EXTENDED_COMPOSITION',
    'UPDATE_ORDER',
    'UPDATE_STYLES',
    'VIEW_ALL_BRANDS',
    'VIEW_ORDER',
] as const;

type PermissionName = (typeof KNOWN_PERMISSION_NAMES)[number];

export { KNOWN_PERMISSION_NAMES };
export type { PermissionName };
